import {
  Component,
  AfterViewInit,
  ViewChild,
  ElementRef,
  ComponentRef,
  ComponentFactoryResolver,
  ApplicationRef,
  Injector,
  EmbeddedViewRef,
} from '@angular/core';
import { BooleanStateService } from 'src/app/modules/core/services/boolean-state.service';
import { WidgetRequestComponent } from 'src/app/modules/widget/components/widget-request/widget-request.component';
import { CommunicationService } from 'src/app/services/communication';
import { ParameterHandlerService } from 'projects/common/src/app/services';
import { StatusFrontComponent } from '../status-front/status-front.component';
import { DrillsMachineService } from 'src/app/modules/dashboard/services/drills/drills-machine.service';
import { IFrontGroup } from 'src/app/modules/widget/interfaces/front-group';
import { ScreenViewService } from 'src/app/modules/widget/services/screen-view.service';

@Component({
  selector: 'app-status-front-group',
  templateUrl: './status-front-group.component.html',
  styleUrls: ['./status-front-group.component.scss'],
  providers: [BooleanStateService],
})
export class StatusFrontGroupComponent extends WidgetRequestComponent implements AfterViewInit {
  @ViewChild('statusFront', { read: ElementRef, static: false })
  public statusFrontView: ElementRef;

  public availableStatus: any[];
  public activeStatus: boolean;
  public statusFrontComponent: ComponentRef<any>[];
  public visibleData: boolean;
  public isLoading: boolean;
  private isFirstCall: boolean;
  public collection: IFrontGroup[] = [];

  constructor(
    public booleanBarService: BooleanStateService,
    public communication: CommunicationService,
    public parameterService: ParameterHandlerService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector,
    private drillsMachineService: DrillsMachineService,
    protected screenViewService: ScreenViewService,
  ) {
    super(booleanBarService, communication, screenViewService);
    this.visibleData = true;
    this.availableStatus = [
      { name: 'all', value: 0, color: 'none', status: null },
      { name: 'active', value: 0, color: 'green', status: true },
      { name: 'inactive', value: 0, color: 'gray', status: false },
    ];
  }

  /**
   * Init app
   */
  public ngAfterViewInit(): void {
    this.isFirstCall = true;
    this.parameterService.parameterSource.item('machine-context').subscribe(
      () => {
        this.isLoading = true;
        this.initCollection();
      },
      (error) => {},
    );

    this.parameterService.parameterSource.item('shift').subscribe(
      () => {
        if (!this.isFirstCall) {
          this.isLoading = true;
          this.initCollection();
        }
      },
      (error) => {},
    );

    this.parameterService.parameterSource.item('date').subscribe(
      () => {
        if (!this.isFirstCall) {
          this.isLoading = true;
          this.initCollection();
        }
      },
      (error) => {},
    );

    this.isFirstCall = false;
  }

  /**
   * Function to load machine status component
   */
  public loadComponentData(collection?: IFrontGroup[]): void {
    this.destroyAllComponents();

    if (!collection) {
      collection = this.collection;
    }

    for (const front of collection) {
      const componentRef = this.componentFactoryResolver.resolveComponentFactory(StatusFrontComponent).create(this.injector);

      componentRef.instance.front = front;
      componentRef.instance.length = this.collection.length;

      this.appRef.attachView(componentRef.hostView);

      const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
      this.statusFrontView.nativeElement.appendChild(domElem);
      this.statusFrontComponent.push(componentRef);
    }
    this.isLoading = false;

    this.visibleData = !!this.collection.length;
  }

  /**
   * Function to clear the statusFrontComponent array and destroy its components
   */
  private destroyAllComponents(): void {
    if (this.statusFrontComponent) {
      for (const component of this.statusFrontComponent) {
        component.destroy();
      }
    }

    this.statusFrontComponent = [];
  }

  /**
   * Load the status type to machine in collection
   */
  private initCollection(selectedStatus?: boolean): void {
    this.isLoading = true;

    this.drillsMachineService.getFrontMachines().subscribe(
      (response: any) => {
        this.collection = this.drillsMachineService.groupZonesByFront(response.data);

        this.availableStatus[0].value = this.collection.length;
        this.availableStatus[1].value = this.collection.filter((value) => value.status === true).length;
        this.availableStatus[2].value = this.collection.filter((value) => value.status === false).length;

        if (selectedStatus !== null && selectedStatus !== undefined) {
          if (selectedStatus) {
            this.collection = this.collection.filter((value) => value.status === true);
          } else {
            this.collection = this.collection.filter((value) => value.status === false);
          }
        }

        this.loadComponentData();
      },
      (error) => {},
    );
  }

  /**
   * Function to select fronts by status
   *
   * @param status Front status
   */
  public statusSelection(status: boolean): void {
    this.activeStatus = status;
    this.initCollection(status);
  }
}
